import { useDemoSession } from '../auth/DemoSessionProvider';
import { isReadOnlySession } from '../auth/access';
import { isJwtAuth } from '../auth/authMode';
import { getWorkspace, workspaceIdForPath } from '../auth/workspaces';
import { UnconfiguredWorkspacePanel } from '../components/workspace/UnconfiguredWorkspacePanel';
import { WorkspaceAccessPage } from '../pages/auth/WorkspaceAccessPage';
import { Outlet, useLocation } from 'react-router-dom';

export function WorkspaceGate({
  title,
  subtitle,
  headingClassName,
  titleClassName,
  subtitleClassName,
}) {
  const { pathname } = useLocation();
  const { session, ready } = useDemoSession();
  const requiredWorkspaceId = workspaceIdForPath(pathname);
  const jwtMode = isJwtAuth();

  if (jwtMode && ready === false) {
    return <p className="text-sm text-eorig-muted">Restoring session…</p>;
  }

  if (requiredWorkspaceId && session && requiredWorkspaceId !== session.workspaceId) {
    return (
      <WorkspaceAccessPage
        requiredWorkspace={getWorkspace(requiredWorkspaceId)}
      />
    );
  }

  if (session && !session.configured && !jwtMode) {
    return <UnconfiguredWorkspacePanel workspace={getWorkspace(session.workspaceId)} />;
  }

  if (jwtMode && session && !session.configured) {
    return <p className="text-sm text-eorig-muted">Session expired. Please sign in again.</p>;
  }

  return (
    <>
      {isReadOnlySession(session) ? (
        <div
          className="mb-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-950"
          role="status"
        >
          Investor access — read-only. You can see every organisation,
          package, transaction and audit entry on the platform, including who
          did what and when. No action can be started from this workspace.
        </div>
      ) : null}
      {title ? (
        <div className={headingClassName || 'mb-5'}>
          <h1
            className={
              titleClassName ||
              'text-lg font-semibold tracking-tight text-eorig-ink sm:text-xl'
            }
          >
            {title}
          </h1>
          {subtitle ? (
            <p
              className={
                subtitleClassName ||
                'mt-1 max-w-3xl text-[13px] leading-relaxed text-eorig-muted'
              }
            >
              {subtitle}
            </p>
          ) : null}
        </div>
      ) : null}
      <Outlet />
    </>
  );
}
